module.exports = [{
      plugin: require('/Users/marvinfrachet/Soft/rnp/rn-placeholder/website/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/marvinfrachet/Soft/rnp/rn-placeholder/website/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"gatsbyRemarkPlugins":["gatsby-remark-autolink-headers"]},
    },{
      plugin: require('/Users/marvinfrachet/Soft/rnp/rn-placeholder/website/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["Roboto"]}},
    },{
      plugin: require('/Users/marvinfrachet/Soft/rnp/rn-placeholder/website/node_modules/gatsby-plugin-react-native-web/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/marvinfrachet/Soft/rnp/rn-placeholder/website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
